export default {
    init() {
        // JavaScript to be fired on all pages

        /** GLOBAL VARIABLES */
        // var body = document.querySelector('body');
        /** END GLOBAL VARIABLES */

        /** SKIP LINK NAVIGATION */
        $('#skip-to-content').click(function () {
        // strip the leading hash and declare
        // the content we're skipping to
        var skipTo = "#" + this.href.split('#')[1];
        // Setting 'tabindex' to -1 takes an element out of normal 
        // tab flow but allows it to be focused via javascript
        $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
            // when focus leaves this element, 
            // remove the tabindex attribute
            $(this).removeAttr('tabindex');
        }).focus(); // focus on the content container
        });
        /** END SKIP LINK NAVIGATION */

        /* HEADER SCROLL EFFECT */
        // Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
        var $body = document.querySelector('body');

        var animatedHeader = (function () { // eslint-disable-line no-unused-vars
            var didScroll = false,
                scrollOffset = $('header.header').innerHeight();
            function scrollY() {
                return window.pageYOffset || document.documentElement.scrollTop;
            }
            function scrollPage() {
                var sy = scrollY();
                if (sy > scrollOffset) {
                    $body.classList.add('scroll-triggered');
                }
                else {
                    $body.classList.remove('scroll-triggered');
                }
                didScroll = false;
            }
            function init() {
                window.addEventListener('load', scrollPage);
                window.addEventListener('scroll', function (event) { // eslint-disable-line no-unused-vars
                    if (!didScroll) {
                        didScroll = true;
                        setTimeout(scrollPage, 250);
                    }
                }, false);
            }
            init();
        })();
        /* END HEADER SCROLL EFFECT */

        /** SHOW AND HIDE SEARCH BAR **/
		var $searchButton = $('.header__search-button'),
        $headerMain = $('.header__inner'),
        $headerSearch = $('.header__search'),
        $searchClose = $('.header__search-close');

        $searchButton.on('click', function(e) {
            e.preventDefault();
            $headerMain.fadeToggle('fast', function() {
                $headerSearch.fadeToggle('slow');
                // Focus on input for all browsers except IE11. They have a placeholder text bug.
                if ( (window.ActiveXObject) && !("ActiveXObject" in window) ) {
                    $headerSearch.find('input[type="text"]').focus();
                }
            });
            $('.header').addClass('header--search-open');
            return false;
        });
        $searchClose.on('click', function() {
            $headerSearch.fadeToggle('fast', function(){
                $headerMain.fadeToggle('fast');
                $('.header').removeClass('header--search-open');
            });
        });

        // Mobile Navigation

        // Change header class for styles on nav icon click
        $('.header__nav-icon').on('click', function () {
            $('.header').toggleClass('header--mobile-nav-open');
        });

        // Add sub-menu icons to menu items with children
        $('.mobile-nav .menu-item-has-children').append('<i></i>');

        $('.mobile-nav .menu-item-has-children i').on('click', function() {
            $(this).parent('.menu-item-has-children').toggleClass('menu-item-has-children--open').find('.sub-menu').slideToggle('fast');
        });


        /** MASTHEAD PROGRESSIVE IMAGES **/

        // Only run if not blog or single story
        if (!$('body').hasClass('blog') && !$('body').hasClass('single-story')) {
            var masthead = document.querySelector('.masthead'),
            placeholderOverlay = document.querySelector('.masthead__overlay');

            if (masthead && placeholderOverlay) {
                // Load full size image. When loaded, fade our placeholder add it as bg to masthead
                var img = new Image();
                img.src = masthead.dataset.imageSrc;
                img.onload = function () {
                    placeholderOverlay.classList.add('fade-out');
                    masthead.style.backgroundImage = "url(" + img.src + ")";
                };
            }
        }
        
        /** END MASTHEAD PRGRESSIVE IMAGES **/

        /** ANIMATED ANCHOR LINKS **/
        $('a[href*="#"]:not([href="#"])').click(function (e) {
            // Doesn't do it on page builder tabs
            if (!$(this).closest('li').hasClass('vc_tta-tab')) {
                if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        var target = $(this.hash);
                        var $this = this;
                        var header = $('header.header');
                        var wpAdminBar = $('#wpadminbar');
                        var fixedHeaderOffset = parseInt(header.outerHeight()) - parseInt(header.css("padding-top").replace("px", ""));
                        // If we're logged in and WP ADmin Bar exists, add it to the offset
                        if ( wpAdminBar.length ) {
                            fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
                        }
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html,body').animate({
                                scrollTop: (target.offset().top - fixedHeaderOffset),
                            }, 500, function () {
                                if (history.pushState) {
                                    history.pushState(null, null, $this.hash);
                                }
                                else {
                                    location.hash = $this.hash;
                                }
                            });
                            e.preventDefault();
                        }
                    }
                }    
            }    
        });
        /** END ANIMATED ANCHOR LINKS **/

        /* IMAGE PARALLAX */

        // Do image parallax
        function imageParallax() { 
            // Set variables
            var $window = $(window);
            // How far we've scrolled 
            var wScroll = $window.scrollTop();
            // Height of window
            var wHeight = $window.height();
            // Position of bottom of window
            var wScrollBottom = wScroll + wHeight;
            // Main image
            var $mainParallaxImage = $('.parallax-image--main');
            // Top parllax images
            var $topParallaxImage = $('.parallax-image--op-left, .parallax-image--top-right');
                // Bottom parllax images
                var $bottomParallaxImage = $('.parallax-image--bottom-left, .parallax-image--bottom-right');

            // Process different parallax effects
            function processParallax(selector, speed) {
                selector.each(function() {
                    // position of element's top from top of window
                    var elTop = $(this).offset().top;
                    var change;
                    // If element is in window, change rate is based on scroll
                    if ( elTop < wHeight ) {
                        change = wScroll;
                    // If element is not in window view, change rate has offset 
                    } else {
                        change = (wScrollBottom - elTop);
                    }
                    // If element is in window do the parallax
                    if( wScrollBottom >  elTop ) {
                        var scaleEl = $(this).hasClass('hover-promo--scaled') ? 'scale(1.1)' : '';
                        $(this).css({'transform' : scaleEl + 'translateY(-' + change/speed + '%)'});
                    }
                });
            }

            // Process parallax for each type of element
            processParallax($mainParallaxImage, 90);
            processParallax($topParallaxImage, 45);
            processParallax($bottomParallaxImage, 110);
        }

        // Only do this if it's not mobile
        if (window.innerWidth > 768 ) {
            // Do parallax effect
            $(window).scroll(imageParallax);
        }
        
        // Page Builder List Item Cards element re-size
        
        // Get all the list item cards on the page
        var $listItemCards = $('.list-item-card.wpb_column');
       
        // Create a function to use on page load and window resize
        function resizeListItemCard() {
            // get the window width. We need to do this within the function to get the new width on resize
            var $windowWidth = $(window).innerWidth();

            // Loop through each list item card
            $listItemCards.each(function() {
                
                var $listItemCardLink = $(this).find('.list-item-card__link');
                var $listItemCardMain = $(this).find('.list-item-card__main');
    
                // Set the bottom of the the link element to center it to the list item card image. Only do it at certain breakpoints
                if (($windowWidth < 576) || ($windowWidth > 767 && $windowWidth < 1450)) {
                    $listItemCardLink.css({'bottom': $listItemCardMain.innerHeight() + 'px'});
                } else {
                    $listItemCardLink.css({'bottom': 0 + 'px'});
                }    
            });
                
        }    

        // Check to see if there are list item cards to prevent JS errors
        if ($listItemCards.length > 0) {

            resizeListItemCard();

            $(window).resize(resizeListItemCard);
        }

        // Reveal animation

        function itemReveal() {
            var itemQueue = [];
            var delay = 100;
            var queueTimer;

    
            function processItemQueue () {
                if (queueTimer) return // We're already processing the queue
                queueTimer = window.setInterval(function () {
                if (itemQueue.length) {
                    $(itemQueue.shift()).addClass('revealed');
                    processItemQueue()
                } else {
                    window.clearInterval(queueTimer)
                    queueTimer = null
                }
                }, delay)
            }
    
            $(".reveal").waypoint(function () {
                itemQueue.push(this.element)
                processItemQueue();
            }, {
                offset: '100%',
            })
            // var waypoints = $('.reveal').waypoint({ // eslint-disable-line no-unused-vars
            //     handler: function(direction) { // eslint-disable-line no-unused-vars
            //     $(this)[0].element.classList.add('revealed');
            //     },
            //     offset: '85%',
            // });
        }
        
        itemReveal();

        // Re-runs waypoints after ajax load more is finished
        $.fn.almComplete = function(alm){ // eslint-disable-line no-unused-vars
            itemReveal();
        };

        // slick slide
        if ($('.visceral-slider').length > 0 ) {
            var slider = $('.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper');
    
            slider.slick({
            slide         : '.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper > *',
            autoplay      : true,
            autoplaySpeed : 6750,
            infinite      : true,
            centerMode    : true,
            centerPadding : '0px',
            cssEase       : 'linear',
            slidesToShow  : 1,
            slidesToScroll: 1,
            swipeToSlide  : true,
            dots          : true,
            arrows        : false,
            fade          : true,
            mobileFirst   : true,
            responsive: [
                {
                breakpoint: 768,
                },
            ],
            });
        }
        
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js